import { api } from "./client";

export interface InventoryParams {
  page?: number;
  pageSize?: number;
  search?: string;
  drugType?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export function getInventory(params?: InventoryParams) {
  return api.get("/inventory", { params });
}

export function getInventoryItem(id: string) {
  return api.get(`/inventory/${id}`);
}

export function searchInventory(query: string) {
  return api.get("/inventory/search", { params: { query } });
}

export function createInventoryItem(data: Record<string, unknown>) {
  return api.post<{
    data: { id: string; ndc: string; item_name: string; drug_type?: string };
  }>("/inventory", data);
}

export function bulkCreateInventory(data: {
  items: Record<string, unknown>[];
  approvalToken?: string;
}) {
  return api.post<{ count: number }>("/inventory/bulk-create", data);
}

export function updateInventory(data: Record<string, unknown>) {
  return api.patch("/inventory/update", data);
}

export function updateThreshold(
  id: string,
  data: { lowStockThreshold: number }
) {
  return api.patch(`/inventory/${id}`, data);
}

export function deleteInventory(data: {
  id: string;
  password?: string;
  approvalToken?: string;
}) {
  return api.delete("/inventory/delete", { body: data });
}

export function adjustStock(data: {
  inventoryId: string;
  reason: string;
  approvalToken?: string;
  adjustment?: number;
  adjustmentDate?: string;
  justification?: string;
  password?: string;
  expectedStock?: number;
  actualStock?: number;
}) {
  return api.post("/inventory/adjust-stock", data);
}

export function auditInventory(data: {
  inventoryId: string;
  physicalCount: number;
  notes?: string;
  approvalToken?: string;
  auditDate?: string;
  reason?: string;
  justification?: string;
  password?: string;
}) {
  return api.post<{ audit: { hasDiscrepancy: boolean } }>(
    "/inventory/audit",
    data
  );
}

export function getInventoryHistory(
  id: string,
  params?: {
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }
) {
  return api.get(`/inventory/${id}/history`, { params });
}

export function getLastAudit(id: string) {
  return api.get(`/inventory/${id}/last-audit`);
}

export function getInventorySnapshot(params?: { date?: string }) {
  return api.get("/inventory/snapshot", { params });
}

export function compareSnapshots(params: {
  startDate: string;
  endDate: string;
}) {
  return api.get("/inventory/snapshot/compare", { params });
}
